import { useSearch } from '@tanstack/react-router';

/**
 * Lê o `quotationVersionId` do search da URL (quando presente). É o que
 * diferencia "ver o resumo da versão X" de "ver a cotação atual": os hooks de
 * carga do Group Life (`useHydrateGroupLifeQuote`, `useGroupLifeQuoteDetails`,
 * `useGroupLifeCalculation`) passam a buscar `getQuoteAtVersion` em vez de
 * `getQuoteDetails` quando este valor existe.
 *
 * Fora da rota do wizard (ou sem o param) devolve `undefined` — aí o
 * comportamento é idêntico ao atual (versão corrente da cotação).
 */
export function useQuotationVersionId(): string | undefined {
  const search = useSearch({ strict: false }) as {
    quotationVersionId?: string;
  };
  const raw = search?.quotationVersionId;
  const trimmed = typeof raw === 'string' ? raw.trim() : '';
  return trimmed || undefined;
}
